
      let options = {"masterHistoryType":"hash","base":"/","shouldNotModifyRuntimePublicPath":true};
      export const getMasterOptions = () => options;
      export const setMasterOptions = (newOpts) => options = ({ ...options, ...newOpts });
      